import { render } from "./AccountingModul.vue?vue&type=template&id=01815f03"
import script from "./AccountingModul.vue?vue&type=script&lang=js"
export * from "./AccountingModul.vue?vue&type=script&lang=js"

import exportComponent from "C:\\inetpub\\wwwroot\\hesabtech-live\\hesabtech-frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__